import { render, staticRenderFns } from "./ExamChoiceComponent.vue?vue&type=template&id=e88a1066&scoped=true&"
import script from "./ExamChoiceComponent.vue?vue&type=script&lang=js&"
export * from "./ExamChoiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExamChoiceComponent.vue?vue&type=style&index=0&id=e88a1066&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88a1066",
  null
  
)

export default component.exports